/**
 * Measuring passes (natural-height reads) must not animate `height`:
 * with the shell's composed list always on the dialog, a "set height, read
 * offsetHeight, set it back" pass would START a transition and read the wrong
 * value. Run `fn` with the `height` entry filtered OUT of the inline
 * transition list (running transform/own entries survive), force a recalc at the
 * end so the reverted layout commits without animating, then put the exact
 * prior inline value back. Synchronous — no paint in between.
 */
export function splitTop(list) {
  const out = [];
  let depth = 0;
  let cur = '';
  for (let i = 0; i < list.length; i += 1) {
    const c = list[i];
    if (c === '(') depth += 1;
    if (c === ')') depth -= 1;
    if (c === ',' && depth === 0) { out.push(cur.trim()); cur = ''; } else cur += c;
  }
  if (cur.trim()) out.push(cur.trim());
  return out;
}

export function withoutHeightTransitions(el, fn) {
  const prev = el.style.transition;
  const kept = prev && prev !== 'none'
    ? splitTop(prev).filter((e) => !/^height\b/.test(e)) : []; // NEVER max-height: it would cancel an in-flight curtain shrink
  el.style.transition = kept.length ? kept.join(', ') : 'none';
  try {
    return fn();
  } finally {
    void el.offsetHeight; // commit the reverted layout with no height transition
    el.style.transition = prev;
  }
}
